/*eslint-disable prefer-const */
import { useEffect, useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import Checkbox from 'src/Admin/components/common/Checkbox';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import AutoSuggestionSelectComponent from 'src/Components/auto-suggestion-select/Select';
import {
  stateOptions,
  genderOptions,
  suffixOptions,
  raceOptions,
  relationshipToInsuredOptions,
} from 'src/utils';
import { toast } from 'react-toastify';
import ToastMessage from '../../../common/ToastMessage';
import APIEndpoints from '../../../../../Member/api/APIEndpoints';
import { HttpSuccessCodes } from 'src/Member/errorhandling/HttpErrorCodes';
import { axiosInstance } from 'src/api/axios';
import {
  setMemberSummaryReject,
  setMemberSummarySuccess,
  setViewMemberInformationSuccess,
} from 'src/redux/member/memberSlice';
import './styles/dependent-info.scss';

const EditDependentContactInfo = ({
  data,
  nextStep,
  prevStep,
  setShowEditDependentsContactDetails,
  enrollmentFormData,
  setEnrollmentFormData,
  dependentInformation,
  activeDependentId,
}) => {
  console.log('data >>>>>  ', data);
  console.log('EditDependentContactInfo activeDependentId', activeDependentId);
  console.log(
    'EditDependentContactInfo enrollmentFormData',
    enrollmentFormData,
  );

  const dispatch = useDispatch();
  const formattedStateOptions = [...stateOptions].map((v) => {
    return { label: v.stateTitle, value: v.State };
  });

  const [useDifferentMailingAddress, setUseDifferentMailingAddress] =
    useState(false);

  const ONLYSPACES = /^(?!\s+$).*/;
  //const ALPHANUMERICONLY = /^[A-Za-z0-9]*$/;
  //const ALPHANUMERICWITHSPACE = /^[A-Za-z0-9. ]*$/;
  //const digitsOnly = (value) => (value ? /^\d+$/.test(value) : true);
  const effective_date =
    enrollmentFormData?.adoptionOrBirthDate &&
    moment(enrollmentFormData?.adoptionOrBirthDate).format('YYYY-MM-DD');

  const oldResAddress = data?.dependentDetails?.OldDependentResidentailAddress
    ? data?.dependentDetails?.OldDependentResidentailAddress
    : data.residenceAddress;

  const oldMailingAddress = data?.dependentDetails?.OldDependentMailingAddress
    ? data?.dependentDetails?.OldDependentMailingAddress
    : data.mailingAddress;

  const { insurerApproval, employerApproval } =
    enrollmentFormData.approvalDetails;

  const validationSchema = yup.object({
    residence_street: yup
      .string()
      .max(55, 'Enter maximum 55 characters only')
      .required('Enter Street Address')
      .nullable()
      .matches(ONLYSPACES, 'Enter Street Address'),
    residence_apartment: yup
      .string()
      .max(55, 'Enter maximum 55 characters only'),
    residence_city: yup
      .string()
      .max(30, 'Enter maximum 30 characters only')
      .required('Enter City')
      .nullable()
      .matches(ONLYSPACES, 'Enter City'),
    residence_state: yup.string().required('Enter State'),
    residence_zip: yup
      .string()
      .max(15, 'Enter maximum 15 characters only')
      .required('Enter Postal Code')
      .nullable()
      .matches(ONLYSPACES, 'Enter Postal Code'),
    mailing_street: yup
      .string()
      .ensure()
      .when('required', {
        is: () => useDifferentMailingAddress,
        then: () =>
          yup
            .string()
            .max(55, 'Enter maximum 55 characters only')
            .required(' Enter Street Address')
            .nullable()
            .matches(ONLYSPACES, 'Enter Street Address'),
        otherwise: () =>
          yup
            .string()
            .notRequired()
            .max(55, 'Enter maximum 55 characters only'),
      }),
    mailing_apartment: yup.string().max(55, 'Enter maximum 55 characters only'),
    mailing_city: yup
      .string()
      .ensure()
      .when('required', {
        is: () => useDifferentMailingAddress,
        then: () =>
          yup
            .string()
            .max(30, 'Enter maximum 30 characters only')
            .required('Enter City')
            .nullable()
            .matches(ONLYSPACES, 'Enter City'),
        otherwise: () =>
          yup
            .string()
            .notRequired()
            .max(30, 'Enter maximum 30 characters only'),
      }),
    mailing_state: yup
      .string()
      .ensure()
      .when('required', {
        is: () => useDifferentMailingAddress,
        then: () => yup.string().required('Enter State'),
        otherwise: () => yup.string().notRequired(),
      }),
    mailing_zip: yup
      .string()
      .ensure()
      .when('required', {
        is: () => useDifferentMailingAddress,
        then: () =>
          yup
            .string()
            .max(15, 'Enter maximum 15 characters only')
            .required('Enter Postal Code')
            .nullable()
            .matches(ONLYSPACES, 'Enter Postal Code'),
        otherwise: () =>
          yup
            .string()
            .notRequired()
            .max(15, 'Enter maximum 15 characters only'),
      }),
  });
  const [loader, setLoader] = useState(false);
  const { loggedInUserOID, loggedInMemberType } = useSelector(
    (state) => state.memberSummary || {},
  );
  const [residenceState, setResidenceState] = useState(
    data?.residenceAddress.State ? data?.residenceAddress.State : '',
  );
  const [mailingResidenceState, setMailingResidenceState] = useState(
    data?.mailingAddress && data?.mailingAddress.State
      ? data?.mailingAddress.State
      : '',
  );

  const selectedResidenceState = formattedStateOptions.filter(
    (option) => option.value === residenceState,
  );

  const selectedMailingResidenceState = formattedStateOptions.filter(
    (option) => option.value === mailingResidenceState,
  );

  const initialValues = {
    residence_street: data?.residenceAddress?.Address1 || '',
    residence_apartment: data?.residenceAddress?.Address2 || '',
    residence_city: data?.residenceAddress?.City || '',
    residence_state: data?.residenceAddress?.State || '',
    residence_zip: data?.residenceAddress?.PostalCode || '',
    mailing_street:
      (data?.mailingAddress && data?.mailingAddress?.Address1) || '',
    mailing_apartment:
      (data?.mailingAddress && data?.mailingAddress?.Address2) || '',
    mailing_city: (data?.mailingAddress && data?.mailingAddress?.City) || '',
    mailing_state: (data?.mailingAddress && data?.mailingAddress?.State) || '',
    mailing_zip:
      (data?.mailingAddress && data?.mailingAddress?.PostalCode) || '',
  };

  console.log('initialValues', initialValues);

  const handlePersonalResidenceStateSelection = (e) => {
    setResidenceState(e.value);
  };
  const handlePersonalMailingResidenceStateSelection = (e) => {
    setMailingResidenceState(e.value);
  };

  /*const getAddressLine = (address) => {
    return `${address?.Address1 ? address?.Address1 : ''} ${
      address?.Address2 ? address?.Address2 : ''
    } ${address?.Address3 ? address?.Address3 : ''} ${
      address?.County ? address?.County : ''
    } ${address?.City ? address?.City + ',' : ''} ${
      address?.State ? address?.State : ''
    }`;
  };

  const getAddressLineZip = (address) => {
    return `${address?.PostalCode ? address?.PostalCode : ''} ${
      address?.Country ? address?.Country : ''
    } `;
  };*/

  const updateAddress = async (values) => {
    console.log('updateAddress', values);
    const dependentResAddress = {
      EffectiveDate: effective_date,
      Address1: values.residence_street,
      Address2: values.residence_apartment,
      Address3: data?.residenceAddress?.Address3,
      County:
        data?.residenceAddress?.City !== values.residence_city ||
        data?.residenceAddress?.State !== values.residence_state ||
        data?.residenceAddress?.PostalCode !== values.residence_zip
          ? null
          : data?.residenceAddress?.County,
      Country: 'USA',
      City: values.residence_city,
      States: values?.residence_state,
      PostalCode: values?.residence_zip,
    };
    let updatedMailingAddress = {
      ...dependentResAddress,
      EffectiveDate: effective_date,
    };
    if (useDifferentMailingAddress === true) {
      updatedMailingAddress = {
        EffectiveDate: effective_date,
        Address1: values.mailing_street,
        Address2: values.mailing_apartment,
        Address3: data?.mailingAddress?.Address3,
        County:
          data?.mailingAddress?.City !== values.mailing_city ||
          data?.mailingAddress?.State !== values.mailing_state ||
          data?.mailingAddress?.PostalCode !== values.mailing_zip
            ? null
            : data?.mailingAddress?.County,
        Country: 'USA',
        City: values.mailing_city,
        States: values?.mailing_state,
        PostalCode: values.mailing_zip,
      };
    }
    /*const dependentAddressDetails = {
      UpdateDependentAddress: {
        DependentMaintenanceAdd: [
          {
            EffectiveDate: data?.residenceAddress?.EffectiveDate,
            Address1: values.residence_street,
            Address2: values.residence_apartment,
            Address3: data?.residenceAddress?.Address3,
            County:
              data?.residenceAddress?.City !== values.residence_city ||
              data?.residenceAddress?.State !== values.residence_state ||
              data?.residenceAddress?.PostalCode !== values.residence_zip
                ? null
                : data?.residenceAddress?.County,
            Country: 'USA',
            City: values.residence_city,
            States: values?.residence_state,
            PostalCode: values?.residence_zip,
          },
        ],
        DependentMailingAddess: [
          {
            EffectiveDate: data?.mailingAddress?.EffectiveDate,
            Address1: values.mailing_street,
            Address2: values.mailing_apartment,
            Address3: data?.mailingAddress?.Address3,
            County:
              data?.mailingAddress?.City !== values.mailing_city ||
              data?.mailingAddress?.State !== values.mailing_state ||
              data?.mailingAddress?.PostalCode !== values.mailing_zip
                ? null
                : data?.mailingAddress?.County,
            Country: 'USA',
            City: values.mailing_city,
            States: values?.mailing_state,
            PostalCode: values.mailing_zip,
          },
        ],
      },
    };*/
    const dependentAddressDetails = {
      AddDependentAddress: {
        DependentMaintenanceAdd: [dependentResAddress],
        DependentMailingAddess: [updatedMailingAddress],
      },
    };

    console.log(
      'updateAddress dependentAddressDetails',
      dependentAddressDetails,
    );
    //if (loggedInMemberType === 'Employee' && dependentInformation === true) {
    //console.log('activeDependentId', activeDependentId);
    //return await axiosInstance.put(
    //`${APIEndpoints.updateDependentUserAddress()}/oid/${activeDependentId}`,
    //dependentAddressDetails,
    //);
    //} else {
    //console.log('IN ELSE API');
    //return await axiosInstance.put(
    //`${APIEndpoints.updateDependentUserAddress()}/oid/${loggedInUserOID}`,
    //dependentAddressDetails,
    //);
    //}
    return await axiosInstance.post(
      `${APIEndpoints.enrollmentAddDependentAddress()}/oid/${activeDependentId}`,
      dependentAddressDetails,
    );
  };

  const getMemberData = async () => {
    try {
      console.log('loggedInUserOID', loggedInUserOID);
      const params = `oid/${loggedInUserOID}/membertype/${loggedInMemberType}`;
      const responseEmployeeData = await axiosInstance.get(
        APIEndpoints.getViewMemberinformation() + params,
      );

      if (
        responseEmployeeData.status ===
          HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        responseEmployeeData.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        console.log('responseEmployeeData', responseEmployeeData);
        dispatch(setViewMemberInformationSuccess(responseEmployeeData.data));
        /*setResidentialData(
          responseEmployeeData?.data?.Response?.Memberresidentailaddress,
        );
        setMailingData(
          responseEmployeeData?.data?.Response?.Membermailingaddress,
        );*/
        /*if (
          loggedInMemberType === 'Dependent' &&
          dependentInformation === true
        ) {
          setsubmitDependentAddress(true);
        } else {
          setsubmitDependentAddress(true);
        }*/
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const handleSubmit = async (values) => {
    console.log('EditDependentContactInfo handleSubmit values', values);
    setLoader(true);
    try {
      if (!insurerApproval && !employerApproval) {
        await updateAddress(values);
        toast.success(
          <ToastMessage
            type="success"
            subTitle="Your address change request has been submitted successfully"
          />,
        );
      }
      const depResidenceAddress = {
        EffectiveDate: data?.residenceAddress?.EffectiveDate,
        Address1: values.residence_street,
        Address2: values.residence_apartment,
        Address3: data?.residenceAddress?.Address3,
        County:
          data?.residenceAddress?.City !== values.residence_city ||
          data?.residenceAddress?.State !== values.residence_state ||
          data?.residenceAddress?.PostalCode !== values.residence_zip
            ? null
            : data?.residenceAddress?.County,
        Country: 'USA',
        City: values.residence_city,
        States: values?.residence_state,
        PostalCode: values?.residence_zip,
      };
      const depResidenceAddressZip = {
        PostalCode: values?.residence_zip,
        Country: 'USA',
      };
      let dependentMailingAddress = {
        ...depResidenceAddress,
        EffectiveDate: data?.mailingAddress?.EffectiveDate,
      };
      let dependentMailingAddressZip = { ...depResidenceAddressZip };
      console.log(
        'dependentMailingAddress >>>>>>>>>> ',
        dependentMailingAddress,
        dependentMailingAddressZip,
      );
      if (useDifferentMailingAddress === true) {
        dependentMailingAddress = {
          EffectiveDate: data?.mailingAddress?.EffectiveDate,
          Address1: values.mailing_street,
          Address2: values.mailing_apartment,
          Address3: data?.mailingAddress?.Address3,
          County:
            data?.mailingAddress?.City !== values.mailing_city ||
            data?.mailingAddress?.State !== values.mailing_state ||
            data?.mailingAddress?.PostalCode !== values.mailing_zip
              ? null
              : data?.mailingAddress?.County,
          Country: 'USA',
          City: values.mailing_city,
          States: values?.mailing_state,
          PostalCode: values.mailing_zip,
        };
        dependentMailingAddressZip = {
          PostalCode: values.mailing_zip,
          Country: 'USA',
        };
      }
      const tempUpdatedAddress = {
        DependentResidentailAddress: depResidenceAddress,
        DependentResidentailAddressZip: depResidenceAddressZip,
        DependentMailingAddress: dependentMailingAddress,
        DependentMailingAddressZip: dependentMailingAddressZip,
      };
      let tempUpdatedValues = data.dependentDetails;
      tempUpdatedValues = {
        ...tempUpdatedValues,
        DependentResidentailAddress:
          tempUpdatedAddress.DependentResidentailAddress,
        DependentResidentailAddressZip:
          tempUpdatedAddress.DependentResidentailAddressZip,
        OldDependentResidentailAddress: oldResAddress,
        OldDependentMailingAddress: oldMailingAddress,
        DependentMailingAddress: tempUpdatedAddress.DependentMailingAddress,
        DependentMailingAddressZip:
          tempUpdatedAddress.DependentMailingAddressZip,
        isDependentUpdated: true,
      };
      console.log(
        'tempUpdatedValues >>>>>>>>>>>> :::::::::  ',
        tempUpdatedValues,
      );
      //const checkDuplicate = enrollmentFormData.updatedDependentDetails;
      const removedDuplicateObject =
        enrollmentFormData.updatedDependentDetails.filter((object) => {
          return (
            object.DepSequenceNumber !== tempUpdatedValues.DepSequenceNumber
          );
        });
      removedDuplicateObject.push(tempUpdatedValues);
      setEnrollmentFormData({
        ...enrollmentFormData,
        updatedCurrentDependentNumber:
          enrollmentFormData.activedependentSequenceNumber,
        updatedDependentDetails: removedDuplicateObject,
      });
      //getMemberData();
    } catch (error) {
      console.log(error);
      toast.error(
        <ToastMessage
          type="error"
          subTitle="Your address change request has not been submitted successfully"
        />,
      );
    } finally {
      setLoader(false);
    }
  };

  return (
    <div>
      <Formik
        validateOnMount={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          const submittedValues = {
            ...values,
            residence_state: residenceState,
            mailing_street: !useDifferentMailingAddress
              ? data?.mailingAddress?.Address1
              : values.mailing_street,
            mailing_apartment: !useDifferentMailingAddress
              ? data?.mailingAddress?.Address2
              : values.mailing_apartment,
            mailing_city: !useDifferentMailingAddress
              ? data?.mailingAddress?.City
              : values.mailing_city,
            mailing_state: !useDifferentMailingAddress
              ? data?.mailingAddress?.State
              : mailingResidenceState,
            mailing_zip: !useDifferentMailingAddress
              ? data?.mailingAddress?.PostalCode
              : values.mailing_zip,
          };
          console.log('submiited values', submittedValues);
          setEnrollmentFormData({
            ...enrollmentFormData,
            dependentAddressInfo: submittedValues,
          });
          setShowEditDependentsContactDetails(false);
          handleSubmit(submittedValues);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          errors,
          isValid,
          handleReset,
          resetForm,
          setFieldTouched,
          setValues,
          setFieldValue,
        }) => {
          console.log('edit member values', values);
          return (
            <Form onSubmit={handleSubmit}>
              <div className="form-main-container">
                <div className="p-0 m-0 mb-2 mt-4 ml-3 form-section">
                  Residential Address
                </div>
                <Row className="m-0">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label>
                        Street Address
                        <span className="form-required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="residence_street"
                        placeholder=""
                        className=""
                        value={values.residence_street}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.residence_street && errors.residence_street
                        }
                        autoCorrect="off"
                        spellCheck="off"
                        autoFocus={false}
                        autoComplete="off"
                      />

                      <Form.Control.Feedback type="invalid">
                        <span role="alert">
                          {touched.residence_street && errors.residence_street}
                        </span>
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="m-0">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label>Apartment/Suit</Form.Label>
                      <Form.Control
                        type="text"
                        name="residence_apartment"
                        placeholder=""
                        className=""
                        value={values.residence_apartment}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.residence_apartment &&
                          errors.residence_apartment
                        }
                        autoCorrect="off"
                        spellCheck="off"
                        autoFocus={false}
                        autoComplete="off"
                      />

                      <Form.Control.Feedback type="invalid">
                        <span role="alert">
                          {touched.residence_apartment &&
                            errors.residence_apartment}
                        </span>
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="m-0">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        City
                        <span className="form-required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="residence_city"
                        placeholder=""
                        className=""
                        value={values.residence_city}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.residence_city && errors.residence_city
                        }
                        autoCorrect="off"
                        spellCheck="off"
                        autoFocus={false}
                        autoComplete="off"
                      />

                      <Form.Control.Feedback type="invalid">
                        <span role="alert">
                          {touched.residence_city && errors.residence_city}
                        </span>
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        State
                        <span className="form-required">*</span>
                      </Form.Label>
                      <AutoSuggestionSelectComponent
                        options={formattedStateOptions}
                        name="residence_state"
                        placeholder="Select State"
                        components={{
                          IndicatorSeparator: () => null,
                        }}
                        value={selectedResidenceState || null}
                        onChange={(e) => {
                          const event = {
                            target: { name: 'residence_state', value: e },
                          };
                          handleChange(event);
                          handlePersonalResidenceStateSelection(e);
                          setFieldValue('residence_state', e.value);
                        }}
                        fieldTouch={setFieldTouched}
                        //isSearchable={false}
                        inputClassName={
                          touched.residence_state && errors.residence_state
                            ? 'select-invalid-error'
                            : ''
                        }
                        isInvalid={
                          touched.residence_state && errors.residence_state
                        }
                      />
                      <div className="invalid-error-feedback">
                        <span role="alert">
                          {touched.residence_state && errors.residence_state}
                        </span>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="m-0">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        Zip
                        <span className="form-required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="residence_zip"
                        placeholder=""
                        className=""
                        value={values.residence_zip}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.residence_zip && errors.residence_zip
                        }
                        autoCorrect="off"
                        spellCheck="off"
                        autoFocus={false}
                        autoComplete="off"
                      />

                      <Form.Control.Feedback type="invalid">
                        <span role="alert">
                          {touched.residence_zip && errors.residence_zip}
                        </span>
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col md={12} className="different-address">
                    <Checkbox
                      label={'Use a different mailing address'}
                      checked={useDifferentMailingAddress}
                      onChange={(e) => {
                        setUseDifferentMailingAddress(e.target.checked);
                        /*setTimeout(() => {
                          if (!e.target.checked) {
                            setFieldValue('mailing_street', '');
                            setFieldValue('mailing_apartment', '');
                            setFieldValue('mailing_city', '');
                            setFieldValue('mailing_state', '');
                            setFieldValue('mailing_zip', '');
                            setMailingResidenceState('');
                          } else {
                            setFieldValue(
                              'mailing_street',
                              data?.Membermailingaddress.Address1,
                            );
                            setFieldValue('mailing_apartment', '');
                            setFieldValue(
                              'mailing_city',
                              data?.Membermailingaddress.City,
                            );
                            setFieldValue(
                              'mailing_state',
                              data?.Membermailingaddress.State,
                            );
                            setFieldValue(
                              'mailing_zip',
                              data?.Membermailingaddress.PostalCode,
                            );
                          }
                        }, 1000);*/
                      }}
                    />
                  </Col>
                </Row>
                {useDifferentMailingAddress && (
                  <>
                    <Row className="m-0 mt-4">
                      <Col md={12}>
                        <div className="p-0 m-0 mb-1 form-section">
                          Mailing Address
                        </div>
                        <Form.Group>
                          <Form.Label>
                            Street Address
                            <span className="form-required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="mailing_street"
                            placeholder=""
                            className=""
                            value={values.mailing_street}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.mailing_street && errors.mailing_street
                            }
                            autoCorrect="off"
                            spellCheck="off"
                            autoFocus={false}
                            autoComplete="off"
                          />

                          <Form.Control.Feedback type="invalid">
                            <span role="alert">
                              {touched.mailing_street && errors.mailing_street}
                            </span>
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="m-0">
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label>Apartment/Suit</Form.Label>
                          <Form.Control
                            type="text"
                            name="mailing_apartment"
                            placeholder=""
                            className=""
                            value={values.mailing_apartment}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.mailing_apartment &&
                              errors.mailing_apartment
                            }
                            autoCorrect="off"
                            spellCheck="off"
                            autoFocus={false}
                            autoComplete="off"
                          />

                          <Form.Control.Feedback type="invalid">
                            <span role="alert">
                              {touched.mailing_apartment &&
                                errors.mailing_apartment}
                            </span>
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="m-0">
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            City
                            <span className="form-required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="mailing_city"
                            placeholder=""
                            className=""
                            value={values.mailing_city}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.mailing_city && errors.mailing_city
                            }
                            autoCorrect="off"
                            spellCheck="off"
                            autoFocus={false}
                            autoComplete="off"
                          />

                          <Form.Control.Feedback type="invalid">
                            <span role="alert">
                              {touched.mailing_city && errors.mailing_city}
                            </span>
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            State
                            <span className="form-required">*</span>
                          </Form.Label>
                          <AutoSuggestionSelectComponent
                            options={formattedStateOptions}
                            name="mailing_state"
                            placeholder="Select State"
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            value={selectedMailingResidenceState || null}
                            onChange={(e) => {
                              const event = {
                                target: {
                                  name: 'mailing_state',
                                  value: e,
                                },
                              };
                              handleChange(event);
                              handlePersonalMailingResidenceStateSelection(e);
                              setFieldValue('mailing_state', e.value);
                            }}
                            fieldTouch={setFieldTouched}
                            //isSearchable={false}
                            inputClassName={
                              touched.mailing_state && errors.mailing_state
                                ? 'select-invalid-error'
                                : ''
                            }
                            isInvalid={
                              touched.mailing_state && errors.mailing_state
                            }
                          />
                          <div className="invalid-error-feedback">
                            <span role="alert">
                              {touched.mailing_state && errors.mailing_state}
                            </span>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="m-0">
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            Zip
                            <span className="form-required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="mailing_zip"
                            placeholder=""
                            className=""
                            value={values.mailing_zip}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.mailing_zip && errors.mailing_zip
                            }
                            autoCorrect="off"
                            spellCheck="off"
                            autoFocus={false}
                            autoComplete="off"
                          />

                          <Form.Control.Feedback type="invalid">
                            <span role="alert">
                              {touched.mailing_zip && errors.mailing_zip}
                            </span>
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                )}
                <Row className="mt-4">
                  <Col md={12} className="different-address">
                    <Checkbox label={'Update same address for Dependent(s)'} />
                  </Col>
                </Row>
                <Form.Group
                  className="form-block mt-1"
                  controlId="buttonsFormGroup"
                  style={{ padding: '16px' }}
                >
                  <Row>
                    <Col className="d-flex justify-content-end">
                      <GenericButton
                        variant="link"
                        onClick={() => {
                          //resetForm();
                          //prevStep();
                          setShowEditDependentsContactDetails(false);
                        }}
                        className="form-btn"
                      >
                        Cancel
                      </GenericButton>
                      <GenericButton
                        type="submit"
                        className="mr-0"
                        disable={!isValid}
                        buttonDisabled={!isValid}
                      >
                        UPDATE AND CONTINUE
                      </GenericButton>
                    </Col>
                  </Row>
                </Form.Group>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default EditDependentContactInfo;
